namespace GeniuzPOS.Administration {
    export class RoleColumns {
        static columnsKey = 'Administration.Role';
    }
}
